var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrowthGearDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 163 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.9299 95.1503H62.9299C64.5299 96.3503 65.2632 101.984 65.4299 104.65H96.9299C95.7299 102.65 97.7632 97.4837 98.9299 95.1503Z",
    fill: "#135FC2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.93 47.6503H61.4299C58.2299 63.6503 60.0966 79.9837 61.4299 86.1503H101.93C104.33 73.3503 102.263 55.1503 100.93 47.6503Z",
    fill: "#135FC2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4299 97.6503L43.4299 104.65C33.0299 99.0503 42.4299 76.6503 48.4299 66.1503C45.2299 74.1503 49.7632 90.4837 52.4299 97.6503Z",
    fill: "#135FC2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9299 38.1503H65.4299C63.8299 30.5503 72.0966 21.9837 76.4299 18.6503V2.65033C80.8299 -2.14967 84.5966 0.650328 85.9299 2.65033V18.6503C93.9299 23.4503 96.5966 33.6503 96.9299 38.1503Z",
    fill: "#135FC2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M117.93 104.65L108.43 97.6503C111.63 99.6503 114.097 76.4837 114.93 64.6504C126.13 92.6504 121.597 102.984 117.93 104.65Z",
    fill: "#135FC2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.93 162.15H4.92969L0.929688 157.65C2.12969 131.25 23.0964 130.984 33.4297 134.15C40.6297 119.35 57.4297 122.984 64.9297 126.651C66.1297 126.651 67.0964 118.984 67.4297 115.15H95.4297C95.0297 123.55 97.9297 126.317 99.4297 126.651C113.83 118.251 126.096 128.15 130.43 134.15C152.43 128.15 160.596 147.984 161.93 158.65L156.93 162.15Z",
    stroke: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.93 37.1504L117.93 48.1504",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M112.43 42.6504H123.43",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M104.43 12.1504H115.43",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9297 37.1504L42.9297 48.1504",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4297 42.6504H48.4297",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4297 12.1504H56.4297",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56.4297,
    cy: 29.1504,
    r: 2,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 105.43 27.1504)",
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 98.4297 4.15039)",
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 70.4297 4.15039)",
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.4297,
    cy: 20.1504,
    r: 2,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 125.43 18.1504)",
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.4297,
    cy: 64.1504,
    r: 2,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 127.43 62.1504)",
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4297,
    cy: 66,
    r: 11,
    fill: "#D9D9D9"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.4297,
    cy: 66,
    r: 5,
    fill: "#135FC2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthGearDark);
export default __webpack_public_path__ + "static/media/GrowthGearDark.86ede98b5b2f7e841ae210f06f28256c.svg";
export { ForwardRef as ReactComponent };